import { render } from "./PreloaderComponent.vue?vue&type=template&id=39b38fc8&scoped=true"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js"

import "./PreloaderComponent.vue?vue&type=style&index=0&id=39b38fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b38fc8"]])

export default __exports__